export const priorities = [
	{ id: 'Baixa', name: 'Baixa' },
	{ id: 'Média', name: 'Média' },
	{ id: 'Alta', name: 'Alta' },
	{ id: 'Urgente', name: 'Urgente' },
]

export const workflowRoutes = [
	{ id: 'area_tecnica', name: 'Área Técnica' },
	{ id: 'diretoria', name: 'Diretoria' },
	{ id: 'nenhuma', name: 'Nenhuma' },
]

export const profileOptions = [
	{ id: 'solicitant', name: 'Solicitante' },
	{ id: 'legal', name: 'Jurídico' },
	{ id: 'admin', name: 'Administrador' },
]

export const profileNameMap = {
	solicitant: 'Solicitante',
	legal: 'Jurídico',
	admin: 'Administrador',
}

export const StatusENUM = [
	'Aguardando ação', // Waiting,
	'Em Validação', // Processing,
	'Em Revisão', // Review,
	'Concluído', // Approved,
	'Atrasado', // Delayed,
	'Cancelado', //  Canceled,
	'Arquivado', // Archived,
]

export const statusOptions = StatusENUM.map((status) => ({
	label: status,
	value: status,
}))

export const ROUTES = {
	docusign: '/docusign-token',
	home: '/',
	dashboard: '/dashboard',
	documents: '/documents',
	form: '/documents/new',
	users: '/users',
	newuser: '/newuser',
	templates: '/models',
	newTemplate: '/models/new',
	editTemplate: '/models/edit',
	documentDetails: '/documents/:id',
	editDocumentDetails: '/documents/:id/edit',
	externalContract: '/documentcreate/:token',
	demands: '/demands',
	demandsCreate: '/demands/new',
	demandsEdit: '/demands/:id/edit',
	demandDetails: '/demands/:id',
	demandChat: '/demands/:id/chat',
	demandsDashboard: '/demands/dashboard',
	textDatabases: '/textdatabases',
	textDatabaseDetails: '/textdatabases/:id(\\d+)',
	internalDatabase: '/internaldatabases',
	internalDatabaseDetails: '/internaldatabases/:id(\\d+)',
	settings: '/settings',
	companies: '/companies',
	signIn: '/sign-in',
	signInSSO: '/sign-in/sso',
	forgotPassword: '/sign-in/forgot-password',
	resetPassword: '/sign-in/reset-password',
	signUp: '/sign-up',
	authCallback: '/auth/callback',
}
